import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, allData, vm, titleData) => {
    try {
      // Loading
      Store.commit('mutateCommonProperties', {
        loading: true
      })

      // Translation
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }

      // API Call
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)

      // PDF
      const pdfContent = []

      //
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                {},
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      // Empty Space
      pdfContent.push(
        { text: '', style: 'empty_space' }
      )

      const allRowsHead = [
        [
          { text: vm.$n(1), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.total_number_of_units_patient_welfare_societies_formed'), style: 'th', alignment: 'left' },
          { text: ':', style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.district_level') + '=' + vm.$n(vm.jelaHos()) + vm.$t('social_service.the') + ', ' + vm.$t('social_service.upazila_level') + '=' + vm.$n(vm.upajelaHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.total_units') + '=' + vm.$n(vm.jelaHos() + vm.upajelaHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.govt_hospital') + '=' + vm.$n(vm.govHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.private_hospital') + '=' + vm.$n(vm.privateHos()) + vm.$t('social_service.the') + ', ' + vm.$t('social_service.medical_college_hospital') + '=' + vm.$n(vm.medicaleHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.specialized_hospital') + '=' + vm.$n(vm.specialHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.general_hospital') + '=' + vm.$n(vm.genaralHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.upazila_health_complex') + '=' + vm.$n(vm.upazilaHos()) + vm.$t('social_service.the') + ' \n ' + vm.$t('social_service.94_nit_hospital_social_service_officer') + vm.$t('social_service.the'), style: 'th', colSpan: 4, alignment: 'left' },
          { },
          { },
          { }
        ],
        [
          { text: vm.$n(2), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.number_patients_receiving_financial'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.number_of_patients_benefited'), style: 'th', colSpan: 4, alignment: 'left' },
          { },
          { },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.financial1'), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.social'), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.rehabilitation1'), style: 'th', alignment: 'left' },
          { text: vm.$t('globalTrans.total'), style: 'th', alignment: 'left' }
        ],
        [
          { },
          { },
          { },
          { text: vm.$n(allData.twoA) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.twoS) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.twoP), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.twoA + allData.twoS + allData.twoP) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' }
        ],
        [
          { text: vm.$n(3), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$i18n.locale === 'en' ? vm.search2.fis.text_en : vm.search2.fis.text_bn + ' ' + vm.$t('social_service.total_number_of_beneficiaries'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.number_of_patients_benefited'), style: 'th', colSpan: 4, alignment: 'left' },
          { },
          { },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.financial1'), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.social'), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.rehabilitation1'), style: 'th', alignment: 'left' },
          { text: vm.$t('globalTrans.total') + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' }
        ],
        [
          { },
          { },
          { },
          { text: vm.$n(allData.threeA) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.threeS) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.threeP), style: 'th', alignment: 'left' },
          { text: vm.$n(allData.threeA + allData.threeS + allData.threeP) + ' ' + vm.$t('social_service.person'), style: 'th', alignment: 'left' }
        ],
        [
          { text: vm.$n(4), style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.from') + '' + vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.number_of_patients_receiving_financial_assistance'), style: 'th', alignment: 'left' },
          { text: ':', style: 'th', alignment: 'left' },
          { text: vm.$n(allData.four) + ' ' + vm.$t('social_service.person'), style: 'th', colSpan: 4, alignment: 'left' },
          { },
          { },
          { }
        ],
        [
          { text: vm.$n(5), style: 'th', rowSpan: 4, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.income_of_patient_welfare_associations_420'), style: 'th', rowSpan: 4, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 4, alignment: 'left' },
          { text: vm.$t('social_service.loc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.fiveA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.mon'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.fiveB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.soc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.fiveC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.tot_inc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.fiveA + allData.fiveB + allData.fiveC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(6), style: 'th', rowSpan: 4, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.income_of_patient_welfare_associations_420'), style: 'th', rowSpan: 4, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 4, alignment: 'left' },
          { text: vm.$t('social_service.loc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.sixA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.mon'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.sixB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.soc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.sixC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.tot_inc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.sixA + allData.sixB + allData.sixC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(7), style: 'th', alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + vm.$t('social_service.income_of_patient_welfare_associations_total'), style: 'th', alignment: 'left' },
          { text: ':', style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.sum'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.fiveA + allData.fiveB + allData.fiveC + allData.sixA + allData.sixB + allData.sixC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(8), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$i18n.locale === 'en' ? vm.search2.fis.text_en : vm.search2.fis.text_bn + ' ' + vm.$t('social_service.total_income_from_reporting_month_financial_year'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$t('social_service.hos_inc'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.eightA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.leve_hos'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.eightB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.tot_income'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.eightA + allData.eightB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(9), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.getMonthNameById(vm.search.month_id) + ' ' + vm.getYearName(vm.search.year_id) + ' ' + vm.$t('social_service.total_expenditure_patient_welfare_societies'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$t('social_service.oe_tot_expen'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.nineA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.ft_tot_expen'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.nineB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.te'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.nineA + allData.nineB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(10), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$i18n.locale === 'en' ? vm.search2.fis.text_en : vm.search2.fis.text_bn + ' ' + vm.$t('social_service.total_expenditure_from_reporting_month_financial_year'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$t('social_service.patient_welfare_a_e'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.tenA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.patient_welfare'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.tenB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.te'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.tenA + allData.tenB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(11), style: 'th', rowSpan: 4, alignment: 'left' },
          { text: vm.$t('social_service.current_bank_status'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$t('social_service.oe_bs'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.elevenA) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.ft_bi'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.elevenB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.tba'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.elevenA + allData.elevenB) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { },
          { text: vm.$t('social_service.current_status'), style: 'th', alignment: 'left' },
          { text: ':', style: 'th', alignment: 'left' },
          { text: vm.$t('social_service.current_status1'), style: 'th', colSpan: 2, alignment: 'left' },
          { },
          { text: vm.$n(allData.elevenC) + '/-', style: 'th', colSpan: 2, alignment: 'left' },
          { }
        ],
        [
          { text: vm.$n(12), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$i18n.locale === 'en' ? vm.search2.fis.text_en : vm.search2.fis.text_bn + ' ' + vm.$t('social_service.grants_by_national_social_welfare_council_during_financial_year') + vm.$i18n.locale === 'en' ? vm.search2.fis.text_en : vm.search2.fis.text_bn + vm.$t('social_service.grants_by_national_social_welfare_council_during_financial_year'), style: 'th', rowSpan: 3, alignment: 'left' },
          { text: ':', style: 'th', rowSpan: 3, alignment: 'left' },
          { text: vm.$t('social_service.national_social_grant_108_hospitals') + ' = ' + vm.$n(allData.twelveA) + '/-', style: 'th', colSpan: 4, alignment: 'right' },
          { },
          { },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.national_social_grant_420_hospitals') + ' = ' + vm.$n(allData.twelveB) + '/-', style: 'th', colSpan: 4, alignment: 'right' },
          { },
          { },
          { }
        ],
        [
          { },
          { },
          { },
          { text: vm.$t('social_service.tga') + ' = ' + vm.$n(allData.twelveA + allData.twelveB) + '/-', style: 'th', colSpan: 4, alignment: 'right' },
          { },
          { },
          { }
        ]
      ]
      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['4%', '33%', '3%', '15%', '15%', '15%', '15%'],
          body: allRowsHead
        }
      })

      var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageMargins: [20, 20, 20, 20],
      pageOrientation: 'portrait',
      styles: {
          // th: {
          //   fontSize: 10,
          //   margin: [4, 3, 3, 3]
          // },
          th1: {
            fontSize: 8,
            margin: [1, 1, 1, 1],
            bold: true
          },
          th: {
            fontSize: 7,
            margin: [1, 1, 1, 1],
            bold: true
          },
          td: {
            fontSize: 8,
            margin: [1, 1, 1, 1]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'left'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'left'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          left_logo: {
            borderRadius: 50
          },
          allRowsHead: {
            margin: [2, 2, 2, 2]
          },
          empty_space: {
            margin: [2, 2, 2, 2]
          }
        }
      }
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
        //
      }
    }

    // Loading Complete
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}

export default {
  exportPdfDetails
}
